import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../components/_utils/CommonToast";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import {
  beneBankLookUp,
  beneDeniedAccount,
  beneWaitingApproved,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  beneLookUp,
  viewAccountDetail,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";

const BeneficiaryAccountSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    labels: "",
  });

  const services = useSelector((state) => state.refreshToken.services);

  const { viewAccountDetailData } = useSelector((state) => state.verify);

  const beneLookData = useSelector((state) => state.verify);

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const accountApproval = () => {
    (async () => {
      setShowLoader();
      toast.dismiss();
      CommonToast({
        text: "Beneficiary account getting approved.",
        variant: "var(--processing)",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      });
      let response = await dispatch(beneWaitingApproved(id));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Beneficiary account approved.",
          variant: "var(--success)",
          icon: ICONS.SELECTED_WITH_WHITE_FILLED,
        });

        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
          {
            replace: true,
          },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.beneficiary_account[0],
          variant: "var(--error)",
          icon: ICONS.INFO_FILLED,
        });
      }
    })();
  };
  const accountRejected = () => {
    (async () => {
      setShowLoader();
      toast.dismiss();
      CommonToast({
        text: "Beneficiary account getting rejected.",
        variant: "var(--processing)",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      });
      let response = await dispatch(beneDeniedAccount({ id, AccountIdData }));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Beneficiary account rejected.",
          variant: "var(--success)",
          icon: ICONS.SELECTED_WITH_WHITE_FILLED,
        });

        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
          {
            replace: true,
          },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.beneficiary_account[0],
          variant: "var(--error)",
          icon: ICONS.INFO_FILLED,
        });
        setRejectPopup(false);
      }
    })();
  };

  const accountData = viewAccountDetailData?.beneficiary_accounts[0];

  useEffect(() => {
    if (accountData) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
      } = accountData;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels,
      });
    }
  }, [accountData]);

  const createTxnHandler = () => {
    navigate(
      "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
      {
        state: currentAccountDetails,
      },
    );
  };

  const createAccountHandler = () => {
    navigate("/beneficiary_account_dashboard/create_beneficiary_account", {
      replace: true,
    });
  };

  const viewDetailsHandler = () => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
      {
        state: true,
      },
    );
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_account_dashboard", {
      replace: true,
    });
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  useEffect(() => {
    dispatch(viewAccountDetail({ id }));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(beneLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      beneBankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);
  const buttonRows = [
    ...(services?.includes("BAAccount") ||
    (services?.includes("Admin") && accountData?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_CIRCLE_RED_ICON,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECTED_WITH_WHITE_FILLED,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),

    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.SELECTUSER,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createTxnHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  const handleInputChange = (event) => {
    let value = event?.target?.value;
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    value = value.slice(0, 150);
    setDeclineReason(value);
  };

  const AccountIdData = declineReason;

  const filteredAccounts = benebankLookData?.beneficiary_accounts?.filter(
    (acc) => {
      const status = acc?.approval_status?.toLowerCase()?.trim();
      return ["pending", "approved"].includes(status);
    },
  );

  return (
    <div>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            // noteText="Before rejecting the account, any matched transactions (if present) will need to be unmatched in the following steps."
            noteColor="text-secondary"
            inputPlaceholder={globalText.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              accountRejected();
              setDeclineReason("");
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          "Beneficiary account created successfully and awaiting approval."
        }
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.category,
                  leftSubTitle: "Assigned categories",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(accountData?.name),
                  leftSubTitle: "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.pan_no,
                  leftSubTitle: "PAN number",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formatAccountNumber(accountData?.bank_acc_no),
                  leftSubTitle: "Account number",
                  ifsc: accountData?.ifsc_code,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.ifsc_code,
                  leftSubTitle: "IFSC code",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.contact_no,
                  leftSubTitle: "Contact number",
                  icon: ICONS.CONTACT_NO,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.email_id,
                  leftSubTitle: "Email ID",
                  icon: ICONS.GMAIL_RED_ERROR,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.gstin_detail
                    ? accountData?.gstin_detail
                    : "Not given",
                  leftSubTitle: "GSTIN (optional)",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array?.isArray(accountData?.labels) &&
                    accountData?.labels?.length >
                      GlobalConfiguration?.lengthCheckZero
                      ? accountData.labels.map((l) => l).join(", ")
                      : "Not assigned",
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.recipient_email
                    ? accountData?.recipient_email
                    : "Not added",
                  leftSubTitle: "Recipients (optional)",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        {beneLookData?.beneLookData?.beneficiary_accounts?.length >
          GlobalConfiguration?.lengthCheckOne && (
          <TabsWeapperSection title="Accounts Associated to PAN">
            {beneLookData?.beneLookData?.beneficiary_accounts
              ?.filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextSize="var(--font-xs)"
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountNameStandardised(
                    accountData?.bank_account_holder_full_name,
                  )}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: formatAccountNumber(accountData?.bank_acc_no),
                      leftSubTitle: "Bank account number",
                      ifsc: accountData?.ifsc_code,
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}

        {Array?.isArray(filteredAccounts) &&
          filteredAccounts.length > GlobalConfiguration?.lengthCheckOne && (
            <TabsWeapperSection title="Accounts Associated to Bank">
              {filteredAccounts.map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextSize="var(--font-xs)"
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountNameStandardised(accountData?.name)}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: accountData?.pan_no,
                      leftSubTitle: "PAN number",
                    },
                  ]}
                />
              ))}
            </TabsWeapperSection>
          )}
      </StatusContainer>
    </div>
  );
};

export default BeneficiaryAccountSuccess;
